import { render, staticRenderFns } from "./Presse.vue?vue&type=template&id=7319d824&"
import script from "./Presse.vue?vue&type=script&lang=js&"
export * from "./Presse.vue?vue&type=script&lang=js&"
import style0 from "./Presse.vue?vue&type=style&index=0&id=7319d824&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports